'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'socks';
var width = 512;
var height = 512;
var aliases = [129510];
var unicode = 'f696';
var svgPathData = ['M16 416c0 44.2 35.8 80 80 80c17.3 0 34.2-5.6 48-16l24.4-18.3C163 447.5 160 432.1 160 416c0-40.3 19-78.2 51.2-102.4l64-48c8.1-6 12.8-15.5 12.8-25.6l0-128-144 0 0 128c0 25.2-11.9 48.9-32 64L48 352c-20.1 15.1-32 38.8-32 64zM144 48l0 48 144 0 0-48c0-8.7 1.4-17.1 4-25c-5.5-4.4-12.4-7-20-7l-96 0c-17.7 0-32 14.3-32 32zm64 368c0 44.2 35.8 80 80 80c17.3 0 34.2-5.6 48-16l115.2-86.4C479.4 372.4 496 339.3 496 304l0-192-160 0 0 128c0 25.2-11.9 48.9-32 64l-64 48c-20.1 15.1-32 38.8-32 64zM336 48l0 48 160 0 0-48c0-17.7-14.3-32-32-32l-96 0c-17.7 0-32 14.3-32 32z', 'M168.4 461.7c2 5.1 4.2 10.1 6.8 14.9l-21.6 16.2C137 505.3 116.8 512 96 512c-53 0-96-43-96-96c0-30.2 14.2-58.7 38.4-76.8l64-48C118.5 279.1 128 260.1 128 240l0-128 0-8 0-8 0-48c0-26.5 21.5-48 48-48l96 0c9.9 0 19 3 26.7 8.1c-2.7 4.7-5 9.7-6.7 14.9c-5.5-4.4-12.4-7-20-7l-96 0c-17.7 0-32 14.3-32 32l0 48 144 0 0 16-144 0 0 128c0 25.2-11.9 48.9-32 64L48 352c-20.1 15.1-32 38.8-32 64c0 44.2 35.8 80 80 80c17.3 0 34.2-5.6 48-16l24.4-18.3zM336 112l0 128c0 25.2-11.9 48.9-32 64l-64 48c-20.1 15.1-32 38.8-32 64c0 44.2 35.8 80 80 80c17.3 0 34.2-5.6 48-16l115.2-86.4C479.4 372.4 496 339.3 496 304l0-192-160 0zm0-16l160 0 0-48c0-17.7-14.3-32-32-32l-96 0c-17.7 0-32 14.3-32 32l0 48zM512 48l0 48 0 8 0 8 0 192c0 40.3-19 78.2-51.2 102.4L345.6 492.8C329 505.3 308.8 512 288 512c-53 0-96-43-96-96c0-30.2 14.2-58.7 38.4-76.8l64-48C310.5 279.1 320 260.1 320 240l0-128 0-8 0-8 0-48c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSocks = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;